<template>
  <v-layout align-center column>
    <img
      src="../../assets/BlogList/Hero.png"
      srcset="
        ../../assets/BlogList/Hero@2x.png 2x,
        ../../assets/BlogList/Hero@3x.png 3x
      "
      class="Hero"
    />
    <p class="Text-Hero" v-bind:style="{ marginTop: marginTopText, width: textWidth }">
      Welcome to Our Blog
    </p>
    <p class="Desc-Hero" v-bind:style="{ marginTop: marginTopDesc, width: descWidth }">
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut viverra neque,
      senectus egestas non est duis. Pellentesque proin lacus, eleifend lectus
      proin sed nisl.
    </p>
  </v-layout>
</template>
<script>
export default {
  data() {
    return {
      heroTextSize: `48px`,
      marginLeft: `${window.innerWidth / 8}px`,
      marginTopText: `${window.innerWidth / 6}px`,
      marginTopDesc: `${window.innerWidth / 6}px`,

      width: `${window.innerWidth / 4}px`,
      fontSize: `40px`,
    };
  },
  mounted() {
    this.onResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
  },
  created() {
    this.resizeEventHandler();
    window.addEventListener("resize", this.resizeEventHandler);
  },
  methods: {
    resizeEventHandler() {
      this.marginLeft = `${window.innerWidth / 8}px`;
      this.marginTopText = `${window.innerWidth / 32}px`;
      this.marginTopDesc = `${window.innerWidth / 13}px`;
      this.descWidth = `${window.innerWidth / 2}px`;
      this.textWidth = `${window.innerWidth / 2}px`;
      this.width = `${window.innerWidth / 3}px`;
      this.fontSize = `${window.innerWidth / 40}px`;
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
  },
};
</script>
<style scoped>
.Text-Hero {
  /* width: 763px; */
  height: 56px;
  margin: 69px auto 0 auto;
  font-family: Sora;
  font-size: 48px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
  /* position: absolute; */
}
.Desc-Hero {
  width: 742px;
  height: 48px;
  margin: -40px auto auto;
  font-family: Sora;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
  position: absolute;
}
.Hero {
  /* width: 1600px; */
  /* height: 490px; */
  margin: -90px 0 427px;
  padding: 0 0 229px;
  object-fit: contain;
  position: relative;
}
</style>
